module.exports = ".modal-borrowed-note {\n    width: 800px;\n}\n\n.modal-borrowed-note .modal-content {\n    padding: 30px;\n}\n\n.lender-detail {\n    margin: 0 !important;\n}\n\n.lender-detail strong{\n    display: block;\n    margin-top: 12px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/consultants/modal-borrowed-note/modal-borrowed-note.css
// module id = ./src/app/views/consultants/modal-borrowed-note/modal-borrowed-note.css
// module chunks = main